<template lang="pug">
  .component-client-action-buttons
    .flex-container.flex-dir-column
      a(v-on:click="openUrl(attachmentUrl)") Download
      a.alert-text(v-on:click="deletec") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper";
  import ClientSmartEdit from "../../../backoffice/smartedits/ClientEdit";

  export default {
    name: "DriverLicenseAttachmentActionButtons",
    components: {
      ClientSmartEdit,
    },
    data() {
      return {}
    },
    created() {


    },
    methods: {
      openUrl: function (url) {
        window.open(url, '_blank')
      },
      deletec() {
        this.$confirm('Are you sure?', 'Do you really want to delete this attachment?', () => {
          KeplerBackofficeSdk.driverLicenses.select(this.licenseId)
            .removeAttachment(this.attachmentId, () => {
              MaggieHelper.notification('delete-esit', 'Attachment deleted')
              window.location.reload()
            })
        })
      },
    },
    props: ['attachmentId', 'licenseId', 'attachmentUrl']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .alert-text
    color: #cc4b37

</style>



// WEBPACK FOOTER //
// DriverLicenseAttachmentActionButtons.vue?0eb19e6b